import { render } from "./RegisterIrvine.vue?vue&type=template&id=05d551fb"
import script from "./RegisterIrvine.vue?vue&type=script&lang=js"
export * from "./RegisterIrvine.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__